"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.exception = exports["default"] = exports.ACTION = void 0;

var _notify = require("./notify");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module actions/error
 */
var config = {
  debug: true
};
var ACTION = {
  ERROR: 'error'
};
exports.ACTION = ACTION;
var _default = config;
exports["default"] = _default;

var exception = function exception(err, handler) {
  handler = handler || function (err) {
    return err.message;
  };

  return function (dispatch) {
    // TODO pretty up
    config.debug && console.log(err);
    dispatch({
      type: ACTION.ERROR,
      err: err
    });
    var mapped = handler(err);
    mapped && dispatch((0, _notify.error)(mapped));
  };
};

exports.exception = exception;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTION.ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.err
      });

    default:
      return state;
  }
};

exports.reducer = reducer;